<p-dialog
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closable]="true"
    [(visible)]="visible"
    (onHide)="hideDialog()"
    [style]="{width: '60%', height: '700px'}">
    <ng-template pTemplate="header">
        <div class="discard-header flex flex-row">
            <i class="pi pi-exclamation-triangle mr-3" style="font-size: 1.6rem"></i>
            {{confirmInput.label}}
        </div>
    </ng-template>
    <div class="flex flex-column text-left mb-3" [innerHtml]="warningMessage"></div>
    <p-divider></p-divider>
    <ng-template pTemplate="body">
        <div class="p-3">
            <div class="flex flex-wrap justify-between gap-4 mb-3">

                <div class="flex flex-column w-full sm:w-5 md:w-5 lg:w-5">
                    <div class="flex flex-row justify-content-between">
                        <span class="label">Product Name & ID:</span>
                        <span class="value">{{product.ProductName + ' (' + product.ProductId + ')'}}</span>
                    </div>
                </div>

                <div class="flex flex-column w-full sm:w-5 md:w-5 lg:w-5">
                    <div class="flex flex-row justify-content-between">
                        <span class="label">Current Status:</span>
                        <span class="value">{{getStatusText(product.Status)}}</span>
                    </div>    
                </div>

                <div class="flex flex-column w-full sm:w-5 md:w-5 lg:w-5">
                    <div class="flex flex-row justify-content-between">
                        <span class="label">Payments Made:</span>
                        <span class="value">{{(product.AmountPaid | currency: 'PHP' : 'symbol' : '1.2-2') + ' (' + product.AmountPaidCount + ' of ' + product.StandardAging + ')'}}</span>
                    </div>
                </div>

                <div class="flex flex-column w-full sm:w-5 md:w-5 lg:w-5">
                    <div class="flex flex-row justify-content-between">
                        <span class="label">Product Price:</span>
                        <span class="value">{{product.Amount | currency: 'PHP' : 'symbol' : '1.2-2'  }}</span>
                    </div>
                </div>

            </div>
            <div *ngIf="selectedStatus === 'Resume' && productComputation" class="border-1 p-4 surface-card text-gray-200 mb-3">
                <div class="flex flex-wrap justify-between gap-4">

                    <div class="flex flex-column w-full sm:w-5 md:w-5 lg:w-5">
                        <div class="flex flex-row justify-content-between">
                            <span class="font-semibold text-600">Last Deduction Date:</span>
                            <span class="value">{{productComputation.LastDeductionDate | date: 'MMM dd, yyyy'}}</span>
                        </div>
                    </div>

                    <div class="flex flex-column w-full sm:w-5 md:w-5 lg:w-5">
                        <div class="flex flex-row justify-content-between">
                            <span class="font-semibold text-600">Amount Repaid:</span>
                            <span class="value">{{(productComputation.AmountRepaid | currency: 'PHP' : 'symbol' : '1.2-2') + ' ('
                             + productComputation.NumOfDaysPaid + ' of ' + productComputation.OriginalDaysAmortization + ' Payments)'}}</span>
                        </div>    
                    </div>

                    <div class="flex flex-column w-full sm:w-5 md:w-5 lg:w-5">
                        <div class="flex flex-row justify-content-between">
                            <span class="font-semibold text-600">Missed Payments:</span>
                            <span class="value">{{(productComputation.AmountFailed | currency: 'PHP' : 'symbol' : '1.2-2') + 
                            ' (' + productComputation.NumOfMissedPayments + ' Days)'}}</span>
                        </div>
                    </div>

                    <div class="flex flex-column w-full sm:w-5 md:w-5 lg:w-5">
                        <div class="flex flex-row justify-content-between">
                            <span class="font-semibold text-600">Balance:</span>
                            <span class="value">{{productComputation.Balance | currency: 'PHP' : 'symbol' : '1.2-2'  }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <p *ngIf="selectedStatus === 'Resume'" class="section-label">New Product Program Information</p>
            <div class="border-1 p-4 surface-card text-gray-200">
                <div class="mb-3">
                    <span class="font-semibold text-600 mr-4">{{selectedStatus === 'Resume' ? 'Resume' : 'Pause'}} Date:</span>
                    <span class="text-900">{{availedDetails.selectedDate | date: 'MMM dd, yyyy' }}</span>
                </div>
                <div *ngIf="selectedStatus === 'Paused'" class="mb-3">
                    <span class="font-semibold text-600 mr-4">Resume Plan:</span>
                    <span class="text-900">{{availedDetails.type}}</span>
                </div>
                <ng-container *ngIf="selectedStatus === 'Resume' && productComputation">
                    <div class="mb-3">
                        <span class="font-semibold text-600 mr-4">New End Date:</span>
                        <span class="text-900">{{productComputation.NewEndDate | date: 'MMM dd, yyyy'}}</span>
                    </div>
                    <div class="mb-3">
                        <span class="font-semibold text-600 mr-4">Deduction Amount:</span>
                        <span class="text-900">{{productComputation.NewAmortization | currency: 'PHP' : 'symbol' : '1.2-2'}}</span>
                    </div>
                </ng-container>
                <div>
                    <span class="font-semibold text-600 mr-4">Change Reason:</span>
                    <span class="text-900">{{availedDetails.specificReason ? availedDetails.reason + ' - ' + availedDetails.specificReason : availedDetails.reason}}</span>
                </div>
            </div>
            <div class="flex flex-row mt-3">
                <span class="label mr-4">Remarks:</span>
                <span class="value">{{availedDetails.remarks ? availedDetails.remarks : '-'}}</span>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="float-left">
            <p-button
                [text]="true"
                label="Back"
                (click)="back()"
                icon="pi pi-angle-left" 
                class="add-product-back-btn"/>
        </div>
        <p-button
            (click)="checkCommerce()"
            label="Update" 
            class="add-product-next-btn"
          />
    </ng-template>
</p-dialog>